module.exports = __webpack_public_path__ + "img/common_goods_reupload.f62d9d53.png";